import {
  IFillDataWizardTradeIn,
  TKeyOfDataWizardTradeIn,
  TNumberKeysOfIFillDataWizardTradeIn,
} from "../..";
import TradeInStep_1 from "../step_1";
import TradeInStep_10 from "../step_10";
import TradeInStep_2 from "../step_2";
import TradeInStep_3 from "../step_3";
import TradeInStep_4 from "../step_4";
import TradeInStep_5 from "../step_5";
import TradeInStep_6 from "../step_6";
import TradeInStep_7 from "../step_7";
import TradeInStep_8 from "../step_8";
import TradeInStep_9 from "../step_9";

const getTradeInSteps = (
  data: IFillDataWizardTradeIn,
  dataFormEstimate: Partial<IFillDataWizardTradeIn>,
  handleChangeDataObject: (data: Partial<IFillDataWizardTradeIn>) => void,
  handleChangeDataNumber: (
    data: number | number[],
    key: TNumberKeysOfIFillDataWizardTradeIn
  ) => void,
  onReset: (key: TKeyOfDataWizardTradeIn[]) => void,
  disabledAndPrev: {
    isNextStepDisabled_apartmentNumber: boolean;
    isNextStep_estimateWithoutApartment: boolean;
    isNextStepDisabled_selectedPolygonIds: boolean;
    isNextStepDisabled_selectedTypeIds_first: boolean;
    isNextStepDisabled_selectedTypeIds_second: boolean;
    isNextStepDisabled_selectedFacilityTypeOwnFacility: boolean;
    isDoublePrevSteps_location: boolean;
    isTriplePrevSteps_typeFacility: boolean;
  }
) => {
  //сценартий выхода на покупку

  const {
    isNextStepDisabled_apartmentNumber,
    isNextStep_estimateWithoutApartment,
    isNextStepDisabled_selectedPolygonIds,
    isNextStepDisabled_selectedTypeIds_first,
    isNextStepDisabled_selectedTypeIds_second,
    isNextStepDisabled_selectedFacilityTypeOwnFacility,
    isTriplePrevSteps_typeFacility,
    isDoublePrevSteps_location,
  } = disabledAndPrev;

  return [
    <TradeInStep_1
      onChange={handleChangeDataObject}
      onChangePrice={handleChangeDataNumber}
      isNextStepDisabled={isNextStep_estimateWithoutApartment}
      dataFormEstimate={dataFormEstimate}
    />,
    <TradeInStep_2
      isNextStepDisabled={isNextStepDisabled_selectedFacilityTypeOwnFacility}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeOwnFacility}
      onReset={onReset}
    />,
    <TradeInStep_3
      onChange={handleChangeDataNumber}
      isNextStepDisabled={isNextStepDisabled_apartmentNumber}
      data={data.apartmentNumber}
      onReset={onReset}
    />,
    <TradeInStep_4
      buildingId={data.buildingId}
      onChange={handleChangeDataNumber}
      onReset={onReset}
    />,
    <TradeInStep_5
      isNextStepDisabled={isNextStepDisabled_selectedPolygonIds}
      onChange={handleChangeDataNumber}
      data={data.desiredLocationIds}
      onReset={onReset}
      buildingId={data.buildingId}
    />,
    <TradeInStep_6
      isNextStepDisabled={isNextStepDisabled_selectedTypeIds_first}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeIds}
      doublePrevStep={isDoublePrevSteps_location}
      onReset={onReset}
    />,
    <TradeInStep_7
      typeIds={data.selectedFacilityTypeIds}
      selectedPolygonIds={data.desiredLocationIds}
    />,
    <TradeInStep_8
      isNextStepDisabled={isNextStepDisabled_selectedTypeIds_second}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeIds}
      onReset={onReset}
    />,
    <TradeInStep_9
      typeIds={data.selectedFacilityTypeIds}
      selectedPolygonIds={data.desiredLocationIds}
    />,
    <TradeInStep_10
      data={data}
      isTripleStepPrev={isTriplePrevSteps_typeFacility}
    />,
  ];
};

export default getTradeInSteps;
